(
    function() {
        'use strict';
        var angular:angular.IAngularStatic =  require('angular');
        angular.module('prmTranslate').
            factory('PrmTranslationIdToCodeMapping', PrmTranslationIdToCodeMapping);
        const LANGUAGE_KEY_PREFIX = '###';

        function PrmTranslationIdToCodeMapping($translate) {
            let mapping = {};

            let service =  {
                getMapping: getMapping,
                setMapping: setMapping
            };

            return service;

            function getMapping(translationId) {
                return mapping[translationId + LANGUAGE_KEY_PREFIX +$translate.use()];
            }

            function setMapping(translationId, code) {
                mapping[translationId + LANGUAGE_KEY_PREFIX +  $translate.use()] = code;
            }

        }

        PrmTranslationIdToCodeMapping.$inject= ['$translate']
    }
)();



// WEBPACK FOOTER //
// ./src/main/webapp/components/translate/prmTranslationIdToCodeMapping.factory.ts